export const DELETE_BUILDS_FAILED = "DELETE_BUILDS_FAILED";
export const DELETE_BUILDS_LOADING = "DELETE_BUILDS_LOADING";
export const DELETE_BUILDS_SUCCESS = "DELETE_BUILDS_SUCCESS";
export const SET_BUILDS_TO_DELETE = "SET_BUILDS_TO_DELETE";
export const TOGGLE_BULK_BUILD_DELETE = "TOGGLE_BULK_BUILD_DELETE";
export const SET_IS_BUILD_DELETE_CTA_CLICKED =
  "SET_IS_BUILD_DELETE_CTA_CLICKED";
export const RESET_BULK_BUILDS_FOR_DELETION = "RESET_BULK_BUILDS_FOR_DELETION";
